<!-- Navbar whit the option of list we get -->
<header class="header_class">
  <h1 class="mb-4 page_title">
    Management
  </h1>

  <nav class="nav">
    <div class="nav-div">
      <a class="nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isManageUserActive }"
        (click)="userManagementClicked()">
          User Management
      </a>
      @if (this.manageService.userHasRoles('_developper', true)) {
        <a class="nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isManageSystemMessageActive }"
          (click)="systemMessageManagementClicked()">
            Maintenance and messages
        </a>
      }
      @if (this.manageService.userHasRoles(['_developper', '_itnova'], true)) {
        <a class="nav-link" href="javascript:void(0)" [ngClass]="{ 'active' : isInformationMessageActive }"
          (click)="informationManagementClicked()">
            Information messages
        </a>
      }
    </div>
  </nav>
</header>

<section class="section-app-admin">

  <!-- List component that manage-admin have -->
  @if (this.isManageUserActive) {
    <app-manage-user></app-manage-user>
  }
  @if (this.isManageSystemMessageActive) {
    <app-manage-system-message></app-manage-system-message>
  }
</section>

<app-system-message></app-system-message>
